import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: [
      'Your clients may require professional indemnity insurance on some contracts.',
      'No professional indemnity insurance yet? Protect your work in only 3 minutes thanks to our insurance partner Assurup.',
    ],
    knowMore: 'Learn more',
    title: 'What about protecting your work?',
  },
  fr: {
    description: [
      'Vos client·es peuvent exiger une assurance responsabilité civile professionnelle (RC pro) sur certains contrats.',
      "Pas encore d'assurance RC pro ? Protégez votre activité en 3 minutes auprès d'Assurup, notre partenaire assureur.",
    ],
    knowMore: 'En savoir plus',
    title: 'Avez-vous pensé à assurer votre travail\xA0?',
  },
} as const);

export default locales;
